import { Close, Info } from '@mui/icons-material'
import { Grid, IconButton, Typography, useMediaQuery } from '@mui/material'

interface AlertBoxProps {
  setShowAlert: React.Dispatch<React.SetStateAction<boolean>>
  children?: React.ReactNode
}

export const AlertBox = ({
  setShowAlert: setShowAlert,
  children,
}: AlertBoxProps) => {
  const matches = useMediaQuery('(min-width:750px)')
  return (
    <Grid
      container
      width={'100%'}
      alignItems={'center'}
      justifyContent={'space-between'}
      wrap={'nowrap'}
      paddingLeft={'16px'}
      sx={{
        background: '#FDF4E9',
        borderRadius: '8px',
        // filter: 'drop-shadow(0px 4px 4px rgba(49, 49, 49, 0.05))', // FIXME: makes alert sometimes invisible
      }}
    >
      <Grid item />
      <Grid
        item
        container
        maxWidth={'1200px'}
        wrap={'nowrap'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Grid
          item
          alignSelf={matches ? '' : 'start'}
          justifySelf={matches ? '' : 'start'}
          marginTop={matches ? 0 : '14px'}
          sx={{ minWidth: '40px' }}
        >
          <Info sx={{ color: '#EF9020', width: '30px', paddingTop: '3px' }} />
        </Grid>
        <Grid item>
          <Typography
            fontSize={'16px'}
            fontWeight={400}
            paddingY={'16px'}
            color="#EF9020"
          >
            {children}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        justifySelf={'end'}
        alignSelf={matches ? '' : 'start'}
        sx={{ minWidth: '40px', paddingRight: '20px' }}
      >
        <IconButton onClick={() => setShowAlert(false)}>
          <Close sx={{ color: '#EF9020', paddingTop: '5px' }} />
        </IconButton>
      </Grid>
    </Grid>
  )
}
